import KunLoading70 from './src/index'

KunLoading70.install = function (Vue) {
	Vue.component(KunLoading70.name, KunLoading70);
}

export default KunLoading70;
